package input

import com.soywiz.klogger.*
import com.soywiz.korev.*
import com.soywiz.korge.baseview.*
import com.soywiz.korge.component.*
import com.soywiz.korge.ui.*
import com.soywiz.korge.view.*
import com.soywiz.korim.bitmap.*
import com.soywiz.korim.color.*
import ui.*

private val LOG = Logger<KeyboardController>()

fun Container.addKeyboardController(
    width: Double,
    height: Double,
    dashIcon: BmpSlice,
    dashActiveIcon: BmpSlice,
    dashDisabledIcon: BmpSlice,
): InputControllerData {
    val keyboardControllerView = solidRect(1, 1, Colors.TRANSPARENT_BLACK)
    val keyboardController = KeyboardController(keyboardControllerView)
    keyboardControllerView.addComponent(keyboardController)

    val textWidth = height / 8.0
    val textHeight = 32.0

    val firstAbility = uiText("FA")
        .position(width - textWidth * 1.1, height - textHeight * 1.1)
    val secondAbility = uiText("SA")
        .position(firstAbility.x - textWidth * 1.1, firstAbility.y)


    val dashSize = height / 8.0 * 1.0
    val dashButton = CustomButton(
        label = "",
        width = dashSize,
        height = dashSize,
        icon = dashIcon,
        activeIcon = dashActiveIcon,
        disabledIcon = dashDisabledIcon,
        buttonId = OnScreenControllerArrows.DASH
    ).apply {
    }
    dashButton.container.addTo(this)
    dashButton.container.position(20.0, height / 5.0)

    return InputControllerData(
        controller = keyboardController,
        stick = null,
        jumpButton = null,
        firstAbilityButton = AbilityButton(firstAbility, firstAbility),
        secondAbilityButton = AbilityButton(secondAbility, secondAbility),
        dashButton = dashButton
    )
}

class KeyboardController(
    override val view: BaseView,
) : InputController, KeyComponent {

    override val left = KeyState()
    override val right = KeyState()
    override val down = KeyState()

    override val jump = KeyState()

    override val firstAbility = KeyState()
    override val secondAbility = KeyState()

    override val dash = KeyState()

    override fun Views.onKeyEvent(event: KeyEvent) {
        when (event.key) {
            Key.A, Key.LEFT-> {
                left.changeStateByType(event.type)
            }

            Key.D, Key.RIGHT -> {
                right.changeStateByType(event.type)
            }

            Key.SPACE, Key.UP -> {
                jump.changeStateByType(event.type)
            }

            Key.S, Key.DOWN -> {
                down.changeStateByType(event.type)
            }

            Key.E -> {
                firstAbility.changeStateByType(event.type)
            }

            Key.Q -> {
                secondAbility.changeStateByType(event.type)
            }

            Key.F -> {
                dash.changeStateByType(event.type)
            }

            else -> {}
        }
    }
}
